import { useState } from "react"
import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog"
import type { Clip } from "./types"

export function DeleteClipDialog({ clip, open, onOpenChange }: {
  clip: Clip
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const [deleting, setDeleting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  function deleteClip() {
    if (deleting) return
    setError(null)
    setDeleting(true)
    router.delete(`/clips/${clip.id}`, {
      onSuccess: () => onOpenChange(false),
      onError: (errors) => setError(errors.deletion || "Deletion could not be completed. Please try again."),
      onFinish: () => setDeleting(false),
    })
  }

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!deleting) onOpenChange(next) }}>
      <DialogContent size="sm" onClick={(event) => event.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>Delete clip?</DialogTitle>
          <DialogDescription>
            This permanently removes “{clip.title || clip.current_filename || "Untitled clip"}”
            and its metadata, thumbnails, and activity from Tubery. <strong>It also deletes the
            video file from Dropbox and devices synced to Dropbox.</strong>
          </DialogDescription>
        </DialogHeader>
        <p className="modal-description">Tubery cannot undo this. The video may be recoverable in Dropbox during your plan’s recovery window.</p>
        {error && <p role="alert">{error}</p>}
        <DialogFooter>
          <Button variant="secondary" disabled={deleting} onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button variant="danger" disabled={deleting} onClick={deleteClip}>
            {deleting ? "Deleting…" : "Delete from Tubery & Dropbox"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
